import { fetcher } from "../../../data/fetcher";

export const fetchSignedUrl = async (file) => {
  const { url } = await fetcher.post(
    `/files/${file.entityType}/${file.entityId}/${file.bucketKey}`
  )({});

  return url;
};
